'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _slicedToArray2 = require('babel-runtime/helpers/slicedToArray');

var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDropzone = require('react-dropzone');

var _reactDropzone2 = _interopRequireDefault(_reactDropzone);

var _uuid = require('uuid');

var _uuid2 = _interopRequireDefault(_uuid);

var _immutable = require('immutable');

var _filesize = require('filesize');

var _filesize2 = _interopRequireDefault(_filesize);

var _lodash = require('lodash');

var _firekit = require('@upgrowth/firekit');

var _firebase = require('firebase');

var _firebase2 = _interopRequireDefault(_firebase);

var _reactFulcrum = require('@upgrowth/react-fulcrum');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var Progress = function Progress(_ref) {
  var percent = _ref.percent;
  return _react2.default.createElement('div', {
    className: 'progress'
  }, percent, '%');
};

var FileEditor = function (_React$Component) {
  (0, _inherits3.default)(FileEditor, _React$Component);

  function FileEditor(props) {
    (0, _classCallCheck3.default)(this, FileEditor);

    var _this = (0, _possibleConstructorReturn3.default)(this, (FileEditor.__proto__ || (0, _getPrototypeOf2.default)(FileEditor)).call(this, props));

    _this.uploadPromise = _promise2.default.resolve();
    _this.state = {
      uploadingProgress: (0, _immutable.OrderedMap)()
    };
    var app = (0, _firekit.firekit)().app;
    _this.storageRef = app.storage().ref('content/');
    _this.stateChanged = _firebase2.default.storage.TaskEvent.STATE_CHANGED;
    return _this;
  }

  (0, _createClass3.default)(FileEditor, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _props = this.props,
          name = _props.name,
          type = _props.type,
          context = _props.context;
      var value = context.value;
      var description = type.description,
          label = type.label,
          _type$variant = type.variant,
          variant = _type$variant === undefined ? "none" : _type$variant;

      if (!value || Array.isArray(value)) {
        value = {};
      }

      var uploadingProgress = this.state.uploadingProgress;
      var file = value;
      var _file$url = file.url,
          url = _file$url === undefined ? "" : _file$url;
      var underway = uploadingProgress && uploadingProgress.progress !== undefined;
      var backgroundImage = !(0, _lodash.isEmpty)(file) && file.type.search(/^image\//) !== -1 ? url : undefined;
      return _react2.default.createElement('div', {
        className: 'FileEditor variant-' + variant
      }, _react2.default.createElement(_reactDropzone2.default, {
        className: 'dropzone',
        style: {
          backgroundImage: 'url(' + backgroundImage + ')'
        },
        onDropAccepted: function onDropAccepted(files) {
          return _this2.handleDrop(files);
        },
        multiple: false
      }, underway && _react2.default.createElement(Progress, {
        percent: Math.round(uploadingProgress.progress * 100),
        progress: true
      }), !underway && (0, _lodash.isEmpty)(value) && _react2.default.createElement('div', {
        className: 'helper-text'
      }, 'Click or drag file here to upload'), !underway && !(0, _lodash.isEmpty)(value) && _react2.default.createElement('div', {
        className: 'file-info'
      }, _react2.default.createElement('p', {
        className: 'file-name'
      }, file.name), _react2.default.createElement('p', {
        className: 'file-details'
      }, file.type, ' - ', (0, _filesize2.default)(file.size)))), _react2.default.createElement('div', {
        className: 'actions'
      }, !(0, _lodash.isEmpty)(value) && _react2.default.createElement(_reactFulcrum.Button, {
        onClick: function onClick(e) {
          return window.confirm("Delete image?") && _this2.handleDelete(e);
        }
      }, 'Delete'), !(0, _lodash.isEmpty)(value) && _react2.default.createElement(_reactFulcrum.Button, {
        as: 'a',
        target: '_blank',
        href: file.url
      }, 'View')));
    }
  }, {
    key: 'handleDrop',
    value: function handleDrop(files) {
      var _this3 = this;

      files.forEach(function (file) {
        file.uuid = (0, _uuid2.default)();
      });
      var newProgress = (0, _lodash.first)(files.map(function (file) {
        return [file.uuid, {
          progress: 0,
          preview: file.preview,
          name: file.name
        }];
      }));
      this.setState({
        uploadingProgress: newProgress
      });
      this.uploadPromise = this.uploadPromise.then(function () {
        return _this3.uploadNext(files);
      });
    }
  }, {
    key: 'uploadNext',
    value: function uploadNext(files) {
      var _this4 = this;

      if (files.length === 0) {
        return;
      }

      var file = files.shift();
      var storedFilename = file.uuid + '-' + file.name;
      var fileRef = this.storageRef.child(storedFilename);
      var task = fileRef.put(file);
      task.on(this.stateChanged, function (snapshot) {
        return _this4.updateProgress(file.uuid, snapshot);
      });
      return task.then(function (_ref2) {
        var ref = _ref2.ref;
        return _promise2.default.all([ref.fullPath, ref.getDownloadURL()]);
      }).then(function (_ref3) {
        var _ref4 = (0, _slicedToArray3.default)(_ref3, 2),
            fullPath = _ref4[0],
            downloadURL = _ref4[1];

        return _this4.handleCompleted(file, downloadURL, fullPath);
      }).catch(function (error) {
        return _this4.handleError(_uuid2.default, error);
      }).then(function () {
        return _this4.uploadNext(files);
      });
    }
  }, {
    key: 'updateProgress',
    value: function updateProgress(id, snapshot) {
      if (this.state.uploadingProgress !== undefined) {
        this.setState({
          uploadingProgress: (0, _extends3.default)({}, this.state.uploadingProgress, {
            progress: snapshot.bytesTransferred / snapshot.totalBytes
          })
        });
      }
    }
  }, {
    key: 'handleError',
    value: function handleError(id, error) {
      this.setState({
        uploadingProgress: (0, _extends3.default)({}, this.state.uploadingProgress, {
          error: error,
          progress: undefined
        })
      });
      return true;
    }
  }, {
    key: 'handleCompleted',
    value: function handleCompleted(file, url, path) {
      var fileDescriptor = function (_ref5) {
        var lastModifiedDate = _ref5.lastModifiedDate,
            name = _ref5.name,
            size = _ref5.size,
            type = _ref5.type,
            uuid = _ref5.uuid;
        return {
          lastModifiedDate: lastModifiedDate || new Date(),
          name: name,
          size: size,
          type: type,
          uuid: uuid,
          url: url,
          path: path
        };
      }(file);

      this.props.context.onChange(this.props.context.path, fileDescriptor);
      this.setState({
        uploadingProgress: undefined
      });
    }
  }, {
    key: 'handleDelete',
    value: function handleDelete(e) {
      e.preventDefault();
      this.props.context.onChange(this.props.context.path, {});
    }
  }]);
  return FileEditor;
}(_react2.default.Component);

exports.default = FileEditor;